<template>
  <b-card class="w-100">
    <h2>سئو</h2>
    <b-row class="mt-2">
      <b-col cols="12" md="6">
        <b-form-group label="عنوان" label-for="course-seo-title">
          <b-form-input id="course-seo-title" v-model.trim="course.seoTitle" maxlength="250" />
        </b-form-group>
        <span :class="{ 'text-danger': (course.seoTitle || '').length > 60 }">
          تعداد کاراکترهای مجاز <small>{{ (course.seoTitle || '').length }}</small><small class="text-secondary">/60</small>
        </span>
      </b-col>
      <b-col cols="12" md="6">
        <b-row>
          <b-col cols="10">
            <b-form-group label="آدرس" label-for="course-seo-url">
              <b-form-input id="course-seo-url" v-model="seoUrl" maxlength="450" @focus="$event.target.select()" />
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-button class="mt-2 ml-2" variant="warning" @click="copySeoUrl">کپی</b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" class="mt-2">
        <b-form-group class="mb-2" label="توضیحات" label-for="course-seo-description">
          <b-form-textarea id="course-seo-description" v-model.trim="course.seoDescription" maxlength="4000" rows="3" />
        </b-form-group>
        <span :class="{ 'text-danger': (course.seoDescription || '').length > 300 }">
          تعداد کاراکترهای مجاز <small>{{ (course.seoDescription || '').length }}</small><small class="text-secondary">/300</small>
        </span>
      </b-col>
    </b-row>

    <b-card class="mt-1 w-100">

        <h2>نحوه نمایش در گوگل</h2>

        <div class="col-md-12 my-3">
          <!--- serp Desktop --->
          <div class="serp-preview d-lg-flex p-3 d-none flex-column align-items-end">
            <div class="serp-title">
              <h4 style="color: rgb(26, 13, 171)!important">
                {{ course.seoTitle }}
              </h4>
            </div>
            <div class="serp-url">
              <h5  class="d-flex align-items-center flex-wrap" style="color: rgb(0, 102, 33)!important;direction: ltr">
                <span style="overflow-wrap: anywhere">/{{ (course.seoUrl || '').replaceAll(' ', '-') }}</span>
                <span>
                       {{ baseUrl }}
                </span>
              </h5>
            </div>
            <div class="serp-description">
              <h6 style="overflow-wrap: anywhere">
                {{ course.seoDescription }}
              </h6>
            </div>
          </div>
          <!--- serp Mobile --->
          <div class="serp-preview d-lg-none  p-3 d-flex flex-column align-items-end">
            <div class="serp-title">
              <h6>
                {{ course.seoTitle }}
              </h6>
            </div>
            <div class="serp-url d-flex align-items-center flex-wrap">

              <small>{{ (course.seoUrl || '').replaceAll(' ', '-') }}/</small>
              <small>
                {{ baseUrl }}
                <small class="serp-arrow"></small>
              </small>
            </div>
            <div class="serp-description">
              <small>
                {{ course.seoDescription }}
              </small>
            </div>
          </div>
        </div>
      </b-card>
  </b-card>
</template>

<script>
import { BButton, BCard, BCol, BFormGroup, BFormInput, BFormTextarea, BRow } from 'bootstrap-vue'

export default {
  name: 'CourseSeoFields',
  components: { BButton, BCard, BCol, BFormGroup, BFormInput, BFormTextarea, BRow },
  props: {
    course: { type: Object, required: true },
  },
  computed: {
    baseUrl() { return `https://banafshebagheri.com/courses${this.course.courseId || ''}` },
    seoUrl: {
      get() { return this.course.seoUrl || '' },
      set(value) {
        this.course.seoUrl = value
          .replace(/[^\p{L}\p{N}-]+/gu, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '')
      },
    },
  },
  methods: {
    async copySeoUrl() {
      if (this.course.seoUrl) await navigator.clipboard.writeText(this.course.seoUrl)
    },
  },
}
</script>

<style scoped>
.serp-url > h5,
.serp-preview > .serp-url {
  direction: ltr;
}

.serp-url > h5 > span:first-child,
.serp-preview > .serp-url > small:first-child {
  order: 2;
  direction: rtl;
  unicode-bidi: isolate;
}

.serp-url > h5 > span:nth-child(2),
.serp-preview > .serp-url > small:nth-child(2) {
  order: 1;
  direction: ltr;
  unicode-bidi: isolate;
}
</style>
